import { useSnapshot } from "valtio"
import { engagementStore } from "src/modules/engagement/engagementStore"
import { scopeStore } from "src/modules/engagement/components/phases/scope/scopeStore"
import KeyDatesPanel from "@components/keyDates/KeyDatesPanel"

const KeyDates = () => {
  const engagementSnap = useSnapshot(engagementStore)
  const scopeSnap = useSnapshot(scopeStore)

  return (
    <KeyDatesPanel
      engagementId={engagementSnap.selectedEngagement.id}
      objectiveId={scopeSnap.selectedObjectiveId}
    />
  )
}

export default KeyDates
